import {
	Button,
	Column,
	Icon,
	Image,
	Modal,
	Row,
	Text,
} from 'native-base';
import ScreenContainer from '../OneHat/components/ScreenContainer';
import withRedux from '../OneHat/data/hoc/withRedux';
import _ from 'lodash';

export function Proofs(props) {
	const {
			currentQuestion,
			showProofs,
			actions,
		} = props;

	return <Modal
				animationType="slide"
				isOpen={showProofs}
				onClose={() => {
					actions.setShowProofs(false);
				}}
			>
				<Modal.Content maxWidth="400px">
					<Modal.CloseButton />
					<Modal.Header>Scripture Proofs</Modal.Header>
					<Modal.Body>
						<Text>{currentQuestion.getProofsString()}</Text>
					</Modal.Body>
				</Modal.Content>
			</Modal>;
}

export default withRedux(Proofs, [
	'currentQuestion',
	'showProofs',
]);